// extracted by mini-css-extract-plugin
module.exports = {"terms-of-service":"MasterPaymentForm_terms-of-service__23vvv","cvc":"MasterPaymentForm_cvc__3Jm2l"};